var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24.4707C19.1274 24.4707 24.5 19.0981 24.5 12.4707C24.5 5.84329 19.1274 0.470703 12.5 0.470703C5.87258 0.470703 0.5 5.84329 0.5 12.4707C0.5 19.0981 5.87258 24.4707 12.5 24.4707Z",
    fill: "#36B37E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 16.2949L7.63672 13.0527C7.54557 12.9616 7.5 12.8444 7.5 12.7012C7.5 12.5579 7.54557 12.4407 7.63672 12.3496L8.35937 11.6465C8.45052 11.5423 8.56445 11.4902 8.70117 11.4902C8.83789 11.4902 8.95833 11.5423 9.0625 11.6465L11.25 13.834L15.9375 9.14648C16.0416 9.04232 16.1621 8.99023 16.2988 8.99023C16.4355 8.99023 16.5495 9.04232 16.6406 9.14648L17.3633 9.84961C17.4544 9.94075 17.5 10.0579 17.5 10.2012C17.5 10.3444 17.4544 10.4616 17.3633 10.5527L11.6016 16.2949C11.5104 16.3991 11.3932 16.4512 11.25 16.4512C11.1068 16.4512 10.9896 16.3991 10.8984 16.2949Z",
    fill: "#36B37E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.7a004d0e8a4cdceaa3158978eb777755.svg";
export { ForwardRef as ReactComponent };